
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Fuhrman',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Fuhrman.vue